/* eslint-disable import/order */
/* eslint-disable import/no-unresolved */
import { Navigate, RouteObject, useRoutes } from "react-router-dom";
import DashboardPage from "src/pages/DashboardPage";
import PaymentPage from "src/pages/PaymentPage";
import VerifyCustomerPage from "src/pages/VerifyCustomer";
import ReviewLeadDetails from "src/pages/ReviewLeadDetails";
// @ts-ignore
import PaymentResponse from "src/pages/PaymentResponse";
import DownloadAndVerifyDetailsPages from "src/pages/DownloadAndVerifyDetailsPage";
import JointVerifyCustomerPage from "src/pages/JointVerifyCustomer";
import MainLayout from "../../pages/MainLayout";
import LandingPage from "../../pages/LandingPage";
import PageNotFound from "../../pages/PageNotFound";
import useAuth from "../hooks/useAuth";
import NewLeadPage from "src/pages/NewLeadPage";
import FormDetailsPage from "src/pages/FormDetails";

const Router = () => {
  const { token } = useAuth();

  const routes: RouteObject[] = [
    {
      path: "*",
      element: <Navigate to="/404" />
    },
    {
      path: "/",
      element: <LandingPage status={token} />
    },
    {
      path: "review-details",
      element: <VerifyCustomerPage />
    },
    {
      path: "joint-review-details",
      element: <JointVerifyCustomerPage />
    },
    {
      element: <MainLayout status={token} />,
      children: [
        {
          path: "dashboard",
          element: <DashboardPage />
        },
        {
          path: "create-lead-details",
          element: <NewLeadPage />
        },
        {
          path: "form-details/:leadId",
          element: <FormDetailsPage />
        },
        {
          path: "review-details/:leadId",
          element: <DownloadAndVerifyDetailsPages />
        },
        {
          path: "view-lead-details/:leadId",
          element: <ReviewLeadDetails />
        }
      ]
    },
    {
      path: "payment",
      element: <PaymentPage />
    },
    {
      path: "payment/response",
      element: <PaymentResponse />
    },
    {
      path: "/404",
      element: <PageNotFound />
    }
  ];
  const element = useRoutes(routes);
  return element;
};

export default Router;
